import { makeSelector } from "../../../testing/index.js";
const TestingAttrs = {
  clearButton: "data-clear-button"
};
const FilterButtonSelectors = {
  clearButton: makeSelector("Clear button", TestingAttrs.clearButton)
};
export {
  FilterButtonSelectors,
  TestingAttrs
};
